import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronDownIcon } from "lucide-react";
import { SectionCta } from "../SectionCta";
import { faqs } from "../../data/content";
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-cream px-4 py-16 sm:px-6 sm:py-24" aria-labelledby="faq-title" data-id="element-148" data-mp="1223kzg8hxg4h">
      <div className="mx-auto max-w-3xl" data-id="element-149" data-mp="1pro2dup045bn">
        <h2 id="faq-title" className="text-center font-display text-[28px] font-black leading-tight text-ink sm:text-4xl" data-id="element-150" data-mp="1pspp4wfdqg97">
          Frequently Asked Questions
        </h2>

        <div className="mt-10 space-y-3" data-id="element-151" data-mp="1g1cy271enu48">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} className="overflow-hidden rounded-2xl bg-white ring-1 ring-navy-900/10" data-id="element-152" data-mp="1kzegcpr0bpen" data-mpi={i}>
                <h3 data-id="element-153" data-mp="28oz2fhigj2s5">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-brand sm:px-6 sm:py-5" data-id="element-154" data-mp="2dhs8c8pnwh5t">
                    <span className="text-base font-bold leading-snug text-ink sm:text-lg" data-id="element-155" data-mp="2tojv2e26rnkf">{f.q}</span>
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-brand transition-transform duration-200 ease-out ${isOpen ? "rotate-180" : ""}`} aria-hidden="true" data-id="element-156" data-mp="37ff9e5vgewve" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-157" data-mp="3cgurbp2c4n9k">
                  {isOpen && <motion.div id={`faq-panel-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: "auto",
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-158" data-mp="1n0d7w7f7yj30">
                      <p className="px-5 pb-5 text-base leading-relaxed text-muted sm:px-6" data-id="element-159" data-mp="2btludn2ts9d2">{f.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>

      <SectionCta label="I'm ready — give me the Blueprint" data-id="element-160" data-mp="2qpl8pfgj35qn" />
    </section>;
}